@for (cr of crEnCoursDenvoiFiltered; track crEnCoursDenvoiFiltered; let i = $index) {
  <ion-item class="cr_ion_item" lines="none">
    <cr-list-item
      [class.cr_list_item_disabled]="isDraftCrDeletionModeActive"
      item-content
      (click)="goToCrDetails(cr)"
      [cr]="cr"
    ></cr-list-item>
  </ion-item>
}
@for (cr of crListUserFiltered; track crListUserFiltered; let i = $index) {
  <ion-item class="cr_ion_item" lines="none">
    <cr-activite-interne-item
      item-content
      *ngIf="cr.type === 'cr-activite-interne'"
      [cr]="$any(cr)"
      (click)="goToCrActiviteInterneDetails($any(cr))"
    ></cr-activite-interne-item>
    <cr-list-item
      *ngIf="cr.type === 'cr-response'"
      [class.cr_list_item_disabled]="isDraftCrDeletionModeActive"
      item-content
      (click)="goToCrDetails(cr)"
      [cr]="cr"
    ></cr-list-item>
  </ion-item>
}
